export default {
    to: "/dashboard/contacts",
    order: 3,
    icon: "mdi-facebook-messenger",
    title: "Contacts",
    disabled: false,
    value: 0,
    sublinks: [],
}
